import { useEffect } from "react";

const AutoReloadMarketplace = ({ children, reload, onReload }) => {
  useEffect(() => {
    if (reload && onReload) setTimeout(onReload, 300);
  }, [reload]);

  return children;
};

export default AutoReloadMarketplace;
